var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { ApiClient } from '../../api/apiClient';
export function useRegoLookup() {
    var _this = this;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), errorAllowHtml = _c[0], setErrorAllowHtml = _c[1];
    var _d = useState([]), vehicles = _d[0], setVehicles = _d[1];
    var lookupVehicle = function (rego, state, recaptchaToken, stateCode) { return __awaiter(_this, void 0, void 0, function () {
        var response, message, allowHtml, convertedVehicles, err_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    setError(null);
                    setErrorAllowHtml(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ApiClient.lookupVehicle(rego, state, recaptchaToken, stateCode)];
                case 2:
                    response = _a.sent();
                    if (!response.success) {
                        message = response.error || 'Failed to lookup vehicle';
                        allowHtml = response.allow_html || false;
                        setError(message);
                        setErrorAllowHtml(allowHtml);
                        setVehicles([]);
                        throw new Error(message);
                    }
                    else if (response.data && response.data[0] && response.data[0].vehicles) {
                        convertedVehicles = response.data[0].vehicles.map(function (vehicle) {
                            var _a, _b, _c, _d;
                            // Check if the vehicle already matches our interface
                            if (vehicle.model && vehicle.badge && vehicle.manufacturer) {
                                return vehicle;
                            }
                            // Convert from API format to our interface
                            return {
                                model: vehicle.Model || vehicle.model || '',
                                badge: vehicle.Badge || vehicle.variant || '',
                                manufacturer: vehicle.Manufacturer || vehicle.make || '',
                                manufactureYear: vehicle.ManufactureYear || ((_a = vehicle.year) === null || _a === void 0 ? void 0 : _a.toString()) || '',
                                badgeCategoryID: vehicle.BadgeCategoryID || '',
                                bodyType: vehicle.BodyType || vehicle.bodyType || '',
                                cylinders: ((_b = vehicle.Cylinders) === null || _b === void 0 ? void 0 : _b.toString()) || '',
                                description: vehicle.Description || "".concat(vehicle.Manufacturer || vehicle.make, " ").concat(vehicle.Model || vehicle.model, " ").concat(vehicle.Badge || vehicle.variant || ''),
                                doorCount: ((_c = vehicle.DoorCount) === null || _c === void 0 ? void 0 : _c.toString()) || ((_d = vehicle.doors) === null || _d === void 0 ? void 0 : _d.toString()) || '',
                                driveType: vehicle.DriveType || '',
                                engineSize: vehicle.EngineSize || '',
                                fuelTypeBasic: vehicle.FuelTypeBasic || vehicle.fuelType || '',
                                fuelTypeBasicCategoryID: vehicle.FuelTypeBasicCategoryID || '',
                                imageUrl: vehicle.ImageUrl || '',
                                manufacturerCategoryID: vehicle.ManufacturerCategoryID || 0,
                                modelCategoryID: vehicle.ModelCategoryID || 0,
                                seatCount: vehicle.SeatCount || vehicle.seats || 0,
                                series: vehicle.Series || '',
                                seriesCategoryID: vehicle.SeriesCategoryID || 0,
                                thumbUrl: vehicle.ThumbUrl || '',
                                transmissionTypeBasic: vehicle.TransmissionTypeBasic || vehicle.transmission || '',
                                transmissionTypeBasicCategoryID: vehicle.TransmissionTypeBasicCategoryID || '',
                                variantCode: vehicle.VariantCode || vehicle.id || ''
                            };
                        });
                        // Update state
                        setVehicles(convertedVehicles);
                        // Return the converted vehicles directly
                        return [2 /*return*/, convertedVehicles];
                    }
                    else {
                        setVehicles([]);
                        return [2 /*return*/, []];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    message = err_1 instanceof Error && err_1.message ? err_1.message : 'An error occurred while looking up the vehicle';
                    setError(message);
                    setVehicles([]);
                    throw new Error(message);
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return { isLoading: isLoading, error: error, errorAllowHtml: errorAllowHtml, vehicles: vehicles, lookupVehicle: lookupVehicle };
}
